import {BudgetFieldsNames} from "../../real_estate/types/BudgetFieldsNames";

export const RegionFieldsNames = ["region"];
export const CriteriaFieldsNames = ["area", "rooms", BudgetFieldsNames.TOTAL, BudgetFieldsNames.CREDIT, BudgetFieldsNames.RADIO];
export const UserFieldsNames = ["name", "email", "phone", "propertyNotification", "financigServices"];
export const AdditionalCriteriaFieldsNames = ["additional_areas", "kitchen", "floor", "date", "quarters"];
import {BudgetFieldsNames} from "../../real_estate/types/BudgetFieldsNames";

export const RegionFieldsNames = ["region"];
export const CriteriaFieldsNames = ["area", "rooms", BudgetFieldsNames.TOTAL, BudgetFieldsNames.CREDIT, BudgetFieldsNames.RADIO];
export const UserFieldsNames = ["name", "email", "phone", "propertyNotification", "financigServices"];
export const AdditionalCriteriaFieldsNames = ["additional_areas", "kitchen", "floor", "date", "quarters"];
